import { IoCloseOutline } from "react-icons/io5";

export const CloseIcon = ({ ...rest }) => {
  return <IoCloseOutline {...rest} />;
};
